/* eslint-disable react-hooks/exhaustive-deps */
import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Grid,
  styled,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import color from "../../components/utils/Colors";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import ProfileDetails from "./ProfileDetails";
import BankDetails from "./BankDetails";
import ContactDetails from "./ContactDetails";
import MySkills from "./Skill";
import { getUserProfileWithLinkedData } from "../../services/services";
import { useSnackbar } from "../../components/utils/SnackBar";
import { useUser } from "../../services/Context/UserContext";

const Profile: React.FC = () => {
  const [value, setValue] = useState(0);
  const [reload, setReload] = useState<boolean>(false);
  const [profile, setProfile] = useState<any>({});
  const showSnackbar = useSnackbar();
  const { user } = useUser();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const isScreenBelow1050px = useMediaQuery("(max-width:1050px)");

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const ProfileContainer = styled(Box)({
    position: "relative",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  });

  const CoverPicture = styled(Box)<{ coverimage: string }>(
    ({ coverimage }) => ({
      width: "100%",
      // borderRadius: '20px',
      height: "200px",
      overflow: "hidden",
      backgroundImage: `url(${coverimage})`,
      // backgroundImage: 'url("/images/group-bg.png")',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundColor: "white",
      position: "relative",
      "&:hover .edit-icon-wrapper": {
        opacity: 1,
      },
      "@media (max-width: 1050px)": {
        height: "250px",
      },
    }),
  );

  const EditIconWrapper = styled(Box)({
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "10px",
    right: "10px",
    color: "grey",
    borderRadius: "6px",
    padding: "5px",
    cursor: "pointer",
    opacity: 0,
    border: "solid 2px ",
    transition: "opacity 0.3s",
    "&:hover": {
      color: color.firstColor,
    },
  });

  const EditProfileIconWrapper = styled(Box)({
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "40%",
    left: "40%",
    color: "grey",
    borderRadius: "20px",
    padding: "5px",
    cursor: "pointer",
    opacity: 0,
    border: "solid 2px ",
    transition: "opacity 0.3s",
    "&:hover": {
      color: color.firstColor,
    },
  });

  const ProfilePictureContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: "70px",
    left: "20px",
    width: "190px",
    height: "190px",
    borderRadius: "50%",
    overflow: "hidden",
    "&:hover .edit-profile-icon-wrapper": {
      opacity: 1,
    },

    "@media (max-width: 1050px)": {
      width: "140px",
      height: "140px",
      top: "20%",
      left: "50%",
      transform: "translateX(-50%)",
    },
  }));

  const ProfilePicture = styled(Avatar)({
    width: "100%",
    height: "100%",
    border: "5px solid white",
    backgroundColor: "white",
    color: color.secondColor,
    position: "relative",
  });

  const InfoBox = styled(Box)(({ theme }) => ({
    gap: "10px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media (max-width: 1050px)": {
      alignItems: "center",
      marginBottom: "20px",
      padding: "0 20px",
    },
  }));

  const EditProfileButton = styled(Button)({
    color: "grey",
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "220px",
    right: "20px",
    textTransform: "none",
    "&:hover": {
      color: color.firstColor,
    },
    "@media (max-width: 1050px)": {
      position: "relative",
      display: "flex",
      top: "0px",
      left: "0",
      right: "0px",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "5px",
      translate: "0px -25px",
    },
  });

  return (
    <Box
      sx={{
        p: 4,
        pt: 2,
        width: isSmallScreen ? "100%" : "80%",
        margin: "auto",
        // textAlign: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        onClick={handleGoBack}
        sx={{
          margin: 0,
          position: "absolute",
          top: isSmallScreen ? "120px" : "140px",
          color: color.firstColor,
          fontSize: "16px",
          fontWeight: "bold",
          left: isSmallScreen ? 10 : 60,
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ChevronLeft></ChevronLeft> Back
      </Typography>

      <Typography
        sx={{
          color: color.firstColor,
          fontSize: isSmallScreen ? "14px" : "26px",
          fontWeight: "bold",
          cursor: "pointer",
          textAlign: "center",
          width: "100%",
          mb: 4,
          mt: 1.5,
          pb: 3,
          borderBottom: "solid 2px",
          borderColor: color.borderColor,
        }}
      >
        G2I Profile
      </Typography>

      <div>
        <Box
          sx={{
            boxShadow: 2,
            border: "solid 2px",
            borderRadius: "8px",
            overflow: "hidden",
            borderColor: "#cccccc",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              margin: 0,
              // border: "solid 1px #cccccc",
              borderRadius: "20px",
            }}
          >
            <CssBaseline />
            <Box>
              <ProfileContainer>
                <CoverPicture
                  sx={{ boxShadow: 1 }}
                  coverimage={"/assets/Course 3.png"}
                >
                  <EditIconWrapper className="edit-icon-wrapper">
                    <ModeEditOutlineOutlinedIcon
                      onClick={() => {
                        navigate("/edit-profile", {
                          state: { selectedTab: 2, profile },
                        });
                      }}
                    />
                  </EditIconWrapper>
                </CoverPicture>

                <Grid
                  container
                  style={{
                    height: "auto",
                    background: "#f9f9f9",
                    width: "100%",
                  }}
                >
                  <Grid
                    item
                    sx={{
                      width: isScreenBelow1050px ? "100%" : "250px",
                      height: isScreenBelow1050px ? "130px" : "200px",
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "center",
                    }}
                  >
                    <ProfilePictureContainer>
                      <ProfilePicture src={"/assets/pfp.png"} />
                      <EditProfileIconWrapper className="edit-profile-icon-wrapper">
                        <ModeEditOutlineOutlinedIcon
                          onClick={() => {
                            navigate("/edit-profile", {
                              state: { selectedTab: 1, profile },
                            });
                          }}
                        />
                      </EditProfileIconWrapper>
                    </ProfilePictureContainer>

                    <Grid
                      item
                      style={{
                        width: isScreenBelow1050px ? "100%" : "350px",
                        display: "flex",
                        paddingTop: isScreenBelow1050px ? "0px" : "60px",
                        paddingLeft: isScreenBelow1050px ? "20px" : "80px",
                      }}
                    >
                      {!isScreenBelow1050px ? (
                        <InfoBox>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", md: "row" },
                              gap: 2,
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                pl: 2,
                                width: isScreenBelow1050px ? "100%" : "50%",
                                textAlign: isScreenBelow1050px
                                  ? "center"
                                  : "left",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: isScreenBelow1050px
                                    ? "center"
                                    : "flex-start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: color.firstColor,
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                    marginBottom: "5px",
                                    marginRight: { xs: "0", md: "30px" },
                                    paddingTop: { xs: "30px", md: "0px" },
                                  }}
                                >
                                  {user?.name}
                                </Typography>
                              </Box>

                              <Typography
                                style={{
                                  color: color.firstColor,
                                  fontSize: "22px",
                                  fontWeight: "bold",
                                  width: "150px",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "start",
                                  flexDirection: "column",
                                  gap: "10px",
                                }}
                              >
                                <span>Role - {user?.role} </span>
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                width: isScreenBelow1050px ? "100%" : "50%",
                                marginTop: isScreenBelow1050px
                                  ? "10px"
                                  : "20px",
                                textAlign: isScreenBelow1050px
                                  ? "center"
                                  : "left",
                                marginLeft: { xs: "0", md: "200px" },
                              }}
                            ></Box>
                          </Box>
                        </InfoBox>
                      ) : (
                        <InfoBox sx={{ mb: 0 }}>
                          <Typography
                            style={{
                              color: color.firstColor,
                              fontWeight: "bold",
                              fontSize: "32px",
                              width: "fit-content",
                              marginBottom: "-10px",
                            }}
                          >
                            {user?.name}
                          </Typography>

                          <Typography
                            style={{
                              color: color.firstColor,
                              fontWeight: "bold",

                              fontSize: "16px",
                              width: "fit-content",
                            }}
                          >
                            Role - {user?.role}
                          </Typography>
                        </InfoBox>
                      )}
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    style={{
                      width: isScreenBelow1050px ? "100%" : "350px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditProfileButton
                      sx={{ marginTop: { xs: "10px", md: "0px" } }}
                      onClick={() => {
                        navigate("/edit-profile", {
                          state: { selectedTab: 0, profile },
                        });
                      }}
                      startIcon={<ModeEditOutlineOutlinedIcon />}
                    >
                      Edit your profile
                    </EditProfileButton>
                  </Grid>
                </Grid>
              </ProfileContainer>
            </Box>
          </Box>

          <Tabs
            sx={{
              background: color.secondColor,
              mt: 0,
              pt: 1,
              pb: 1,
              px: 1,
              // pt:2,
              flexWrap: "wrap",
              "& .MuiTabs-indicator": {
                display: "none",
                backgroundColor: color.borderColor,
              },
            }}
            value={value}
            onChange={handleChange}
            variant={isSmallScreen ? "scrollable" : "standard"}
            scrollButtons={isSmallScreen ? "auto" : false}
            centered={!isSmallScreen}
          >
            <Tab
              style={{
                color: value === 0 ? color.textColor : "grey",
                textTransform: "none",
                fontWeight: "bold",
                margin: isSmallScreen ? "0px" : "0 20px",
                fontSize: isSmallScreen ? "14px" : "18px",
              }}
              label="Profile"
            />
            <Tab
              style={{
                color: value === 1 ? color.textColor : "grey",
                margin: isSmallScreen ? "0px" : "0 20px",
                textTransform: "none",
                fontWeight: "bold",
                fontSize: isSmallScreen ? "14px" : "18px",
              }}
              label="Bank Details"
            />
            <Tab
              style={{
                color: value === 2 ? color.textColor : "grey",
                textTransform: "none",
                fontWeight: "bold",
                fontSize: isSmallScreen ? "14px" : "18px",
              }}
              label="Contact Info"
            />
            <Tab
              style={{
                color: value === 3 ? color.textColor : "grey",
                textTransform: "none",
                fontWeight: "bold",
                fontSize: isSmallScreen ? "14px" : "18px",
              }}
              label="Skills"
            />
          </Tabs>
        </Box>

        {value === 0 && (
          <>
            <ProfileDetails/>
          </>
        )}
        {value === 1 && (
          <>
            <BankDetails/>
          </>
        )}
        {value === 2 && (
          <>
            <ContactDetails />
          </>
        )}
        {value === 3 && (
          <>
            <MySkills/>
          </>
        )}
      </div>
    </Box>
  );
};

export default Profile;
